import { object, string } from 'yup';
import { loyaltySpecSchema } from '../loyalty-spec-form/loyalty-spec-form.schema';

export const workspaceSchema = object({
  title: string().required().max(255).default(''),
  shortDescription: string().required().max(200).default(''),
  longDescription: string().max(425).default('').nullable(),
  messageFromEmail: string().required().email().max(320).default(''),
  timezone: string().required().default(''),
  address: object().shape({
    streetAddress1: string().required().max(100).default(''),
    streetAddress2: string().max(100).nullable().default(''),
    city: string().required().max(100).default('').nullable(),
    region: string().required().default('').nullable(),
    postalCode: string().required().max(50).default('').nullable(),
    country: string().required().default('United States'),
  }),
});

export const createWorkspaceSchema = object({
  workspace: workspaceSchema,
  loyalty: loyaltySpecSchema,
});
